import React, { useState } from 'react';
import { FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=DM+Sans:wght@400;500;600&display=swap');
.cf-page{font-family:'DM Sans',sans-serif;background:#f5f4f0;min-height:100vh;}
.cf-hero{position:relative;overflow:hidden;padding:4rem 2rem 3rem;background:linear-gradient(135deg,#0b3d4a 0%,#134d5e 55%,#1a6474 100%);}
.cf-orb{position:absolute;border-radius:50%;filter:blur(80px);opacity:.15;pointer-events:none;}
.cf-orb--a{width:450px;height:450px;background:radial-gradient(circle,#e67e22,transparent);top:-100px;right:-70px;}
.cf-orb--b{width:300px;height:300px;background:radial-gradient(circle,#2196a4,transparent);bottom:-70px;left:-50px;}
.cf-hero-inner{position:relative;z-index:1;max-width:680px;margin:0 auto;text-align:center;}
.cf-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(255,255,255,.1);border:1px solid rgba(255,255,255,.2);color:rgba(255,255,255,.85);font-size:.75rem;letter-spacing:.08em;padding:5px 14px;border-radius:999px;margin-bottom:1.25rem;}
.cf-h1{font-family:'Playfair Display',Georgia,serif;font-size:clamp(2rem,5vw,3rem);font-weight:700;color:#fff;margin:0 0 .75rem;line-height:1.15;}
.cf-gold{background:linear-gradient(90deg,#f39c12,#e67e22);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;}
.cf-hero-sub{font-size:1rem;color:rgba(255,255,255,.65);line-height:1.7;margin:0 auto;}
.cf-body{max-width:1100px;margin:0 auto;padding:3.5rem 2rem;}
.cf-grid{display:grid;grid-template-columns:1fr 380px;gap:2.5rem;align-items:start;}
.cf-form-card{background:#fff;border-radius:16px;padding:2rem;box-shadow:0 4px 24px rgba(0,0,0,.07);}
.cf-form-title{font-family:'Playfair Display',serif;font-size:1.4rem;font-weight:700;color:#0b3d4a;margin:0 0 1.5rem;}
.cf-fg{margin-bottom:1.1rem;}
.cf-fg label{display:block;font-size:.82rem;font-weight:600;color:#555;margin-bottom:.4rem;letter-spacing:.02em;}
.cf-fg input,.cf-fg textarea{
  width:100%;padding:.65rem .85rem;border:1.5px solid rgba(0,0,0,.12);border-radius:8px;
  font-family:'DM Sans',sans-serif;font-size:.9rem;color:#1a1a1a;background:#fafafa;
  transition:border-color .2s,box-shadow .2s;box-sizing:border-box;outline:none;
}
.cf-fg input:focus,.cf-fg textarea:focus{border-color:#21808d;box-shadow:0 0 0 3px rgba(33,128,141,.12);background:#fff;}
.cf-fg input:disabled,.cf-fg textarea:disabled{opacity:.6;cursor:not-allowed;}
.cf-fg textarea{min-height:110px;resize:vertical;}
.cf-submit{
  width:100%;padding:.75rem;
  background:linear-gradient(135deg,#21808d,#134d5e);
  color:#fff;border:none;border-radius:8px;
  font-family:'DM Sans',sans-serif;font-size:.95rem;font-weight:600;
  cursor:pointer;transition:transform .2s,box-shadow .2s;
  display:flex;align-items:center;justify-content:center;gap:.5rem;
}
.cf-submit:hover:not(:disabled){transform:translateY(-2px);box-shadow:0 6px 20px rgba(33,128,141,.3);}
.cf-submit:disabled{opacity:.65;cursor:not-allowed;transform:none;}
.cf-spinner{width:16px;height:16px;border:2px solid rgba(255,255,255,.4);border-top-color:#fff;border-radius:50%;animation:cfSpin .7s linear infinite;flex-shrink:0;}
@keyframes cfSpin{to{transform:rotate(360deg)}}
.cf-error-banner{padding:.85rem 1rem;background:#fff3f3;border:1px solid #ffcdd2;border-radius:8px;color:#c62828;font-size:.88rem;margin-bottom:1.25rem;display:flex;align-items:flex-start;gap:.5rem;font-weight:500;}
.cf-info-card{background:#fff;border-radius:16px;padding:1.75rem;box-shadow:0 4px 24px rgba(0,0,0,.07);display:flex;flex-direction:column;gap:1.25rem;}
.cf-info-item{padding-bottom:1.25rem;border-bottom:1px solid rgba(0,0,0,.07);}
.cf-info-item:last-child{border-bottom:none;padding-bottom:0;}
.cf-info-item h4{font-family:'Playfair Display',serif;font-size:.97rem;font-weight:600;color:#0b3d4a;margin:0 0 .35rem;}
.cf-info-item p{font-size:.85rem;color:#666;line-height:1.65;margin:0;}
.cf-socials{display:flex;gap:.75rem;margin-top:.5rem;}
.cf-social-a{width:40px;height:40px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#0b3d4a,#21808d);color:#fff;transition:transform .2s,box-shadow .2s;text-decoration:none;}
.cf-social-a:hover{transform:translateY(-3px);box-shadow:0 6px 16px rgba(33,128,141,.35);}
/* success */
.cf-success-wrap{max-width:520px;margin:3rem auto;text-align:center;padding:3rem 2rem;background:#fff;border-radius:16px;box-shadow:0 4px 24px rgba(0,0,0,.08);border:1px solid #e0f4f5;}
.cf-success-icon{width:72px;height:72px;border-radius:50%;background:linear-gradient(135deg,#21808d,#134d5e);display:flex;align-items:center;justify-content:center;margin:0 auto 1.5rem;font-size:2rem;color:#fff;box-shadow:0 4px 16px rgba(33,128,141,.3);}
.cf-success-h{font-family:'Playfair Display',serif;font-size:1.6rem;font-weight:700;color:#0b3d4a;margin-bottom:.75rem;}
.cf-success-p{font-size:.97rem;color:#555;line-height:1.7;margin-bottom:.5rem;}
.cf-success-note{font-size:.88rem;color:#888;line-height:1.6;margin-bottom:2rem;}
.cf-success-quote{padding:1rem 1.25rem;background:#e8f5f6;border-radius:10px;margin-bottom:2rem;font-size:.88rem;color:#21808d;line-height:1.6;}
.cf-btn-reset{display:inline-flex;align-items:center;gap:.5rem;padding:.7rem 2rem;background:linear-gradient(135deg,#21808d,#134d5e);color:#fff;border:none;border-radius:8px;font-family:'DM Sans',sans-serif;font-size:.9rem;font-weight:600;cursor:pointer;transition:transform .2s,box-shadow .2s;}
.cf-btn-reset:hover{transform:translateY(-2px);box-shadow:0 6px 20px rgba(33,128,141,.3);}
@media(max-width:860px){.cf-grid{grid-template-columns:1fr;}.cf-body{padding:2.5rem 1.25rem;}}
`;

const socials = [
  { id:'fb', name:'Facebook',  url:'https://www.facebook.com/vseva.11org/',  Icon:FaFacebook  },
  { id:'ig', name:'Instagram', url:'https://www.instagram.com/v_seva__/',    Icon:FaInstagram },
  { id:'yt', name:'YouTube',   url:'https://www.youtube.com/@VIVEKASEVA',    Icon:FaYoutube   },
];

const Hero = () => (
  <div className="cf-hero">
    <div className="cf-orb cf-orb--a"/><div className="cf-orb cf-orb--b"/>
    <div className="cf-hero-inner">
      <div className="cf-badge">📬 We'd Love to Hear From You</div>
      <h1 className="cf-h1">Get In <span className="cf-gold">Touch</span></h1>
      <p className="cf-hero-sub">Whether you want to volunteer, donate, or simply learn more — we're here to help.</p>
    </div>
  </div>
);

export default function ContactForm() {
  const [form,     setForm]     = useState({ name:'', email:'', subject:'', message:'' });
  const [status,   setStatus]   = useState('idle'); // 'idle' | 'submitting' | 'success' | 'error'
  const [errorMsg, setErrorMsg] = useState('');

  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5127';

  const change = e => setForm(p => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setStatus('submitting');
    setErrorMsg('');

    try {
      const res = await fetch(`${API_BASE_URL}/api/Contacts`, {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name:    form.name.trim(),
          email:   form.email.trim().toLowerCase(),
          subject: form.subject.trim(),
          message: form.message.trim(),
        }),
      });

      if (!res.ok) {
        const errData = await res.json().catch(() => ({}));
        throw new Error(errData.error || `Server error (${res.status})`);
      }

      setStatus('success');
    } catch (err) {
      setErrorMsg(err.message || 'Something went wrong. Please try again.');
      setStatus('error');
    }
  };

  const reset = () => {
    setForm({ name:'', email:'', subject:'', message:'' });
    setStatus('idle');
    setErrorMsg('');
  };

  // ── Success screen ──────────────────────────────────────────────────────
  if (status === 'success') {
    return (
      <div className="cf-page">
        <style>{CSS}</style>
        <Hero/>
        <div className="cf-body">
          <div className="cf-success-wrap">
            <div className="cf-success-icon">✓</div>
            <h2 className="cf-success-h">Message Sent!</h2>
            <p className="cf-success-p">
              Thank you, <strong>{form.name}</strong>! We've received your message.
            </p>
            <p className="cf-success-note">
              We'll reply to <strong>{form.email}</strong> as soon as possible,
              usually within 1–2 working days.
            </p>
            <div className="cf-success-quote">
              🙏 <em>"They alone live, who live for others." — Swami Vivekananda</em>
            </div>
            <button className="cf-btn-reset" onClick={reset}>
              Send Another Message
            </button>
          </div>
        </div>
      </div>
    );
  }

  // ── Form ────────────────────────────────────────────────────────────────
  return (
    <div className="cf-page">
      <style>{CSS}</style>
      <Hero/>

      <div className="cf-body">
        <div className="cf-grid">

          {/* Form card */}
          <div className="cf-form-card">
            <p className="cf-form-title">Send us a Message</p>

            {status === 'error' && (
              <div className="cf-error-banner">
                <span>⚠️</span>
                <span>{errorMsg}</span>
              </div>
            )}

            <form onSubmit={submit}>
              {[
                ['name',    'Name',    'text' ],
                ['email',   'Email',   'email'],
                ['subject', 'Subject', 'text' ],
              ].map(([n, l, t]) => (
                <div key={n} className="cf-fg">
                  <label>{l} *</label>
                  <input
                    type={t} name={n} value={form[n]}
                    onChange={change} required
                    disabled={status === 'submitting'}
                    placeholder={
                      n === 'name'    ? 'Your full name'    :
                      n === 'email'   ? 'your@email.com'    :
                      'What is this about?'
                    }
                  />
                </div>
              ))}

              <div className="cf-fg">
                <label>Message *</label>
                <textarea
                  name="message" value={form.message}
                  onChange={change} required
                  disabled={status === 'submitting'}
                  placeholder="Tell us how we can help…"
                />
              </div>

              <button type="submit" className="cf-submit" disabled={status === 'submitting'}>
                {status === 'submitting' ? (
                  <><span className="cf-spinner"/>Sending…</>
                ) : (
                  'Send Message →'
                )}
              </button>
            </form>
          </div>

          {/* Info card */}
          <div className="cf-info-card">
            {[
              { h:'📍 Address', p:<>No.10, Bilwarchna Nilaya<br/>9th A Cross, Kavi Ponna Road, Hanumanth Nagar<br/>Bengaluru-560019</> },
              { h:'📞 Phone',   p:<>+91 74838 65803<br/><small style={{color:'#aaa'}}>(Available 9 AM – 6 PM)</small></> },
              { h:'📧 Email',   p:'vivekaseva.org@gmail.com' },
            ].map((item, i) => (
              <div key={i} className="cf-info-item">
                <h4>{item.h}</h4>
                <p>{item.p}</p>
              </div>
            ))}
            <div className="cf-info-item">
              <h4>🌐 Follow Us</h4>
              <div className="cf-socials">
                {socials.map(({ id, name, url, Icon }) => (
                  <a key={id} href={url} target="_blank" rel="noopener noreferrer"
                    className="cf-social-a" title={name} aria-label={name}>
                    <Icon size={18}/>
                  </a>
                ))}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}